import { render, staticRenderFns } from "./consumeCourse.vue?vue&type=template&id=6053208b&scoped=true&"
import script from "./consumeCourse.vue?vue&type=script&lang=js&"
export * from "./consumeCourse.vue?vue&type=script&lang=js&"
import style0 from "./consumeCourse.vue?vue&type=style&index=0&id=6053208b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053208b",
  null
  
)

export default component.exports